export function initPaymentLinkDelivery() {
  const buttons = Array.from(
    document.querySelectorAll<HTMLButtonElement>(
      'button[data-delivery-channel]'
    )
  )
  if (!buttons.length) return

  const deadlines = new Map<HTMLButtonElement, number>()
  const sending = new Set<string>()
  buttons.forEach((button) => {
    deadlines.set(
      button,
      Date.now() + Number(button.dataset.cooldownSeconds) * 1000
    )
  })
  const update = () => {
    buttons.forEach((button) => {
      const channel = button.dataset.deliveryChannel!
      if (sending.has(channel)) return
      const seconds = Math.max(
        0,
        Math.ceil((deadlines.get(button)! - Date.now()) / 1000)
      )
      button.disabled =
        seconds > 0 || button.dataset.recipientMissing === 'true'
      button.textContent =
        seconds > 0
          ? `Повтор через ${seconds} с`
          : button.dataset.deliveryLabel!
    })
  }
  update()
  window.setInterval(update, 1000)
  document
    .querySelectorAll<HTMLFormElement>('form[data-payment-link-delivery]')
    .forEach((form) => {
      form.addEventListener('submit', (event) => {
        const channel = form.dataset.paymentLinkDelivery!
        const button = form.querySelector<HTMLButtonElement>('button')!
        if (sending.has(channel) || button.disabled) {
          event.preventDefault()
          return
        }
        sending.add(channel)
        buttons
          .filter((item) => item.dataset.deliveryChannel === channel)
          .forEach((item) => {
            item.disabled = true
            item.textContent = 'Отправляем…'
          })
      })
    })
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) window.location.reload()
  })
}
